<template>
  <i v-if="name === 'wave'">ここにSVG</i>

  <i class="custom-icon" :class="{ margin: margin }" v-else-if="isCustom(name)">
    <img :src="iconName" :style="{ width: width }" />
  </i>

  <q-icon :name="name" v-else-if="material" />

  <i :class="{ margin: margin }" :style="{ width: width }" v-else>
    <font-awesome-icon :icon="[type, name]" :pulse="pulse" />
  </i>
</template>
<script>
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  // アルファベット順に記載
  faBook,
  faBullhorn,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faAngleDoubleRight,
  faCog,
  faCogs,
  faDollarSign,
  faDownload,
  faEllipsisH,
  faExclamation,
  faExclamationCircle,
  faFileInvoice,
  faFileSignature,
  faInfo,
  faInfoCircle,
  faPen,
  faPhone,
  faPlus,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faSyncAlt,
  faTachometerAlt,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUndo,
  faUser,
  faUserCircle,
  faUserCog,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import {
  faBell,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileAlt,
  faListAlt,
  faQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';

import { faSlack } from '@fortawesome/free-brands-svg-icons';

library.add(
  // Solid
  faBook,
  faBullhorn,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faAngleDoubleRight,
  faCog,
  faCogs,
  faDollarSign,
  faDownload,
  faEllipsisH,
  faExclamation,
  faExclamationCircle,
  faFileInvoice,
  faFileSignature,
  faInfo,
  faInfoCircle,
  faPen,
  faPhone,
  faPlus,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faSyncAlt,
  faTachometerAlt,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUndo,
  faUser,
  faUserCircle,
  faUserCog,

  faUserPlus,

  // Regular
  faBell,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileAlt,
  faListAlt,
  faQuestionCircle,

  // Bland
  faSlack
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

/*
    共通のアイコンコンポーネント
    FontAwesomeを使用。（https://fontawesome.com/how-to-use/on-the-web/using-with/vuejs）


    使い方：
    使用したいアイコンを設定する。Fontawesomeのドキュメント参照。

    <Icon name='icon-name'></Icon>

    [Props]
    name(String)必須  : アイコンの種類を指定
    type(String) : アイコンのタイプ(prefix)を指定。デフォルトは 'fas'。
    margin(String) : アイコンの右側にマージンを追加。
    pulse(Boolean) : アイコンを回転させる。
    width(String) : アイコンの幅を指定。


    [Event]
    click : ボタンをクリック
    */

export default {
  name: 'Icon',
  props: {
    name: { type: String, required: true },
    type: { type: String, default: 'fas' },
    material: { type: Boolean },
    margin: { type: Boolean },
    pulse: { type: Boolean },
    width: { type: String },
  },
  methods: {
    isCustom(name) {
      const splitName = name.split('-');
      return splitName[0] === 'mo';
    },
  },
};
</script>

<style scoped>
i {
  display: inline-block;
}
.margin {
  margin-right: 0.4em;
}
</style>
